import useSeti from '@/hooks/useSeti'
import { useRouter } from 'next/router'
import type { TypeAheadConfigEndpoint } from './types'

export function useFlightAirportNesting(typeAheadEndpoint: TypeAheadConfigEndpoint) {
  const { pathname } = useRouter()
  const isHomepage = pathname === '/'
  const shouldShowNesting = typeAheadEndpoint === 'flights' && isHomepage
  const isAirportNestingEnabled =
    useSeti({
      experimentCode: 'WEB_MWEB_FLIGHT_SEARCH_AIRPORT_NESTING',
      shouldFireImpression: shouldShowNesting,
    }) === 'VARIANT' && shouldShowNesting
  return isAirportNestingEnabled
}
